import http from "../common/http";
import authHeader from "./header";
import {
    SERVICE_API_URL
} from "../common/config";

const galleryRelicFindAll = (params) => {
    return http.get(SERVICE_API_URL + `/galleries/relics`, {
        params: params,
        headers: authHeader(),
    });
};

const galleryRelicFindByGalleryId = (params) => {
    return http.get(SERVICE_API_URL + `/galleries/relics`, {
        params: params,
        headers: authHeader(),
    });
};

const regGalleryRelic = (params) => {
    return http.post(SERVICE_API_URL + `/galleries/relics`, params, {
        headers: authHeader(),
    });
};


const deleteGalleryRelic = (id) =>{
  return http.post(SERVICE_API_URL+`/galleries/relics/delete/${id}`, {}, {
    headers : authHeader()
  })

};
export default {
  galleryRelicFindAll,
  galleryRelicFindByGalleryId,
  regGalleryRelic,
  deleteGalleryRelic
};